import React, { useContext } from 'react';
import {
  Box,
  SubscriptionComponentCard,
  SubscriptionComponentCardVariants,
} from '@chargify/custom-ui-components';

import { ComponentContainer } from '../../containers/ComponentContainer';
import { SubscriptionComponent } from '../SubscriptionComponents/types';
import { ComponentsContext } from '../../contexts';

type Props = {
  /**
   * Components in group
   */
  components: SubscriptionComponent[];
  /**
   * Render in card
   */
  renderInCard?: boolean;
  /**
   * Subscription is active
   */
  subscriptionIsActive?: boolean;
};

const renderComponentContainer = (
  components: SubscriptionComponent[],
  distanceBetweenComponents?: number,
  cardVariant?: SubscriptionComponentCardVariants
) => (
  <>
    {components.map(({ id, componentMachineRef }) => (
      <Box marginBottom={distanceBetweenComponents} key={id}>
        <ComponentContainer
          id={id}
          key={id}
          componentMachineRef={componentMachineRef}
          cardVariant={cardVariant}
        />
      </Box>
    ))}
  </>
);

export const ComponentGroup = ({ components, renderInCard = true }: Props) => {
  const { subscriptionIsActive } = useContext(ComponentsContext);
  const cardVariant = subscriptionIsActive ? 'primary' : 'secondary';
  return (
    <>
      {renderInCard ? (
        <Box marginBottom={2}>
          <SubscriptionComponentCard variant={cardVariant}>
            {renderComponentContainer(components)}
          </SubscriptionComponentCard>
        </Box>
      ) : (
        renderComponentContainer(components, 2, cardVariant)
      )}
    </>
  );
};
